import { render, staticRenderFns } from "./claim-case-template.vue?vue&type=template&id=48aeb5e6&scoped=true&"
import script from "./claim-case-template.vue?vue&type=script&lang=js&"
export * from "./claim-case-template.vue?vue&type=script&lang=js&"
import style0 from "./claim-case-template.vue?vue&type=style&index=0&id=48aeb5e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aeb5e6",
  null
  
)

export default component.exports